const ELLIPSIS = 'ellipsis';

export const PAGINATION_CHROME_BOXES = 4;
export const PAGINATION_DESKTOP_MAX_BOXES = 21;
export const PAGINATION_MOBILE_MAX_BOXES = 12;

export const PAGINATION_DESKTOP_MAX_INNER =
  PAGINATION_DESKTOP_MAX_BOXES - PAGINATION_CHROME_BOXES;
export const PAGINATION_MOBILE_MAX_INNER =
  PAGINATION_MOBILE_MAX_BOXES - PAGINATION_CHROME_BOXES;

export const getPaginationInnerLimit = (isMobile = false) => (
  isMobile ? PAGINATION_MOBILE_MAX_INNER : PAGINATION_DESKTOP_MAX_INNER
);

export const buildPaginationItems = (currentPage, totalPages, maxInner) => {
  const total = Math.max(0, Number(totalPages) || 0);
  const current = Math.min(Math.max(1, Number(currentPage) || 1), Math.max(total, 1));
  const limit = Math.max(5, Number(maxInner) || PAGINATION_DESKTOP_MAX_INNER);

  if (total <= 0) {
    return [];
  }

  if (total <= limit) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const pages = new Set([1, total, current]);
  let offset = 1;
  while (pages.size < limit - 2) {
    const before = current - offset;
    const after = current + offset;
    const canBefore = before > 1;
    const canAfter = after < total;
    if (!canBefore && !canAfter) {
      break;
    }
    if (canBefore) {
      pages.add(before);
    }
    if (pages.size >= limit - 2) {
      break;
    }
    if (canAfter) {
      pages.add(after);
    }
    offset += 1;
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const items = [];
  sorted.forEach((page, index) => {
    if (index > 0 && page - sorted[index - 1] > 1) {
      items.push(`${ELLIPSIS}-${sorted[index - 1]}-${page}`);
    }
    items.push(page);
  });
  return items;
};

export const isPaginationEllipsis = (item) => (
  typeof item === 'string' && item.startsWith(ELLIPSIS)
);
